<template>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Email" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.contact_email ? activeCompany.contact_email : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Phone" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.contact_phone ? activeCompany.contact_phone : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeCompany.contact_address ? activeCompany.contact_address : "-" }}
            </v-col>
        </v-row>
    </div></template
>

<script>
import { mapState } from "vuex";

export default {
    name: "contact-info-view-tab",
    computed: { ...mapState(["activeCompany"]) }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
